import React, { cloneElement } from 'react';
import { BusinessCollection } from '../../data-layer/business/constants';
import { BusinessModel } from '../../data-layer/business/types';
import { BusinessListItem, BusinessListItemSkeleton } from '../../ui/business/BusinessListItem';
import { Flex } from '../../ui/layout/Flex';
import { Stack } from '../../ui/layout/Stack';
import { Typography } from '../../ui/typography/Typography';
import { useBusinessCallbacks } from '../business/useBusinessCallbacks';
import { useBusinessCollection } from '../business/useBusinessCollection';

export const SearchBusiness = () => {
    const collection = useBusinessCollection({
        namespace: BusinessCollection.SEARCH,
    });
    const businessCallbacks = useBusinessCallbacks();

    const getBusiness = (business: BusinessModel) =>
        business ? (
            <BusinessListItem business={business} {...businessCallbacks} />
        ) : (
            <BusinessListItemSkeleton />
        );

    return collection.isLoading || collection.businesses.length > 0 ? (
        <Stack
            width="100%"
            maxWidth="100%"
            count={collection.businesses.length}
            renderItem={(index) =>
                cloneElement(getBusiness(collection.businesses[index]), { key: index })
            }
        />
    ) : (
        <Flex px={3} alignItems="flex-start" justifyContent="center" flexGrow={1} spacing={1}>
            <Typography variant="title2" weight="bold">
                Ничего не найдено
            </Typography>
            <Typography>Попробуйте другой запрос</Typography>
        </Flex>
    );
};
